import { defineComponent as _defineComponent } from 'vue';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
export default /*#__PURE__*/_defineComponent({
  __name: 'CountriesNace',
  props: {
    value: {
      type: [String, Array],
      default: null
    },
    modelValue: {
      type: [String, Array],
      default: null
    },
    multiple: {
      type: Boolean,
      default: true
    },
    options: {
      type: Array,
      required: true
    }
  },
  emits: ['input', 'update:modelValue'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var currentValue = computed(function () {
      var _ref2;
      return (_ref2 = props.modelValue !== undefined && props.modelValue !== null ? props.modelValue : props.value) !== null && _ref2 !== void 0 ? _ref2 : null;
    });
    var onInput = function onInput(event) {
      emit('update:modelValue', event);
      emit('input', event);
    };
    var normalizer = function normalizer(node) {
      return {
        id: node.label,
        label: node.label,
        children: node.children
      };
    };
    return {
      __sfc: true,
      props: props,
      emit: emit,
      currentValue: currentValue,
      onInput: onInput,
      normalizer: normalizer,
      Treeselect: Treeselect
    };
  }
});